import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import Login from './components/Login';
import Home from './components/Home';
import Upload from './components/Upload';
import UpdateExp from './components/UpdateExp';
import UpdatePort from './components/UpdatePort';
import Dashboard from './components/Dashboard';
import DashboardControl from './components/DashboardControl';
import Resultats from './components/Resultats';
import Form from './components/Form';
import FormInfo from './components/FormInfo';
import UpdateEvaluations from './components/UpdateEvaluations';
import AddTribunalMember from './components/AddTribunalMember';
import HometribuAdmin from './components/HometribuAdmin';

function App() {
  return (
    <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/updateexp" element={<UpdateExp />} />
            <Route path="/updateport" element={<UpdatePort />} />
            <Route path="/updateevaluations" element={<UpdateEvaluations />} />
            <Route path="/addtribunal" element={<AddTribunalMember />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/control" element={<DashboardControl />} />
            <Route path="/all" element={<HometribuAdmin />} />
            <Route path="/resultats" element={<Resultats />} />
            <Route path="/form" element={<Form />} />
            <Route path="/forminfo" element={<FormInfo />} />
          </Routes>
    </Router>
  );
}

export default App;
